module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_ext_02_6DD79_1SE_G9K.f89befa1.png";